import request from '@/sheep/request';


export const getHomeData = async () => {
	return request({
		url: '/wish/home/base',
		method: 'GET',
		custom: {
			isToken: false
		}
	});
}

export const getLimitUserProjectList = async () => {
	return request({
		url: '/wish/user-projects/list/home',
		method: 'GET',
	});
}

export const getWishesNearbyCount = async (longitude: number, latitude: number) => {
	return request({
		url: '/wish/home/nearby-count',
		method: 'GET',
		params: { longitude, latitude },
		custom: {
			isToken: false
		}
	});
}